import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout/index';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import'hammerjs';
export class SharedModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    FlexLayoutModule,
    RouterModule

  ],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    FlexLayoutModule,
    RouterModule

  ],
  providers: [],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SharedModule_tsickle_Closure_declarations() {
/** @type {?} */
SharedModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SharedModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
